import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import { StyledNavSticky } from './NavSticky.style'

export const NavSticky = ({ className, children }) => {
  const observed = useRef(null)
  const [stuck, updateStuck] = useState(false)

  useEffect(() => {
    const currentlyObserved = observed.current
    const observation = ([entry]) => {
      updateStuck(entry.intersectionRatio < 1)
    }
    const observer = new IntersectionObserver(observation, {
      threshold: [1.0],
      root: null,
      rootMargin: '-2px 0px 0px 0px',
    })
    if (currentlyObserved) observer.observe(currentlyObserved)
    return () => {
      if (currentlyObserved) observer.unobserve(currentlyObserved)
    }
  }, [observed])

  return (
    <StyledNavSticky
      ref={observed}
      stuck={stuck}
      className={classNames(className, { stuck })}
    >
      {children}
    </StyledNavSticky>
  )
}

NavSticky.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}
